



























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    Distance,
    TransportLoad,
    TransportLoadTransportPartModel,
    TransportLoadTransportPartSaveRequest,
} from "@/models";

import { transportLoadActionService } from "@/services";

import PlanTaskDistanceDialog from "./PlanTaskDistanceDialog.vue";
import VehicleCalendar from "./VehicleCalendar.vue";
import VehicleSelectDialog from "./VehicleSelectDialog.vue";

class TransportPartModel {
    selected: boolean;
    amount: number;
    cityFrom: string;
    cityTo: string;

    type: string;
    vehicleSpecific: boolean;
    description: string;

    constructor(public transportPart: TransportLoadTransportPartModel, load: TransportLoad) {
        this.selected = transportPart.loadTransportPartId != null;
        this.amount = transportPart.plannedValue || 0;
        this.cityFrom = transportPart.cityFrom;
        this.cityTo = transportPart.cityTo;

        this.type = transportPart.part.type;
        this.vehicleSpecific = !!load.vehicleId && load.vehicleId === transportPart.part.vehicleId;
        this.description = transportPart.part.partId + " " + transportPart.part.description + (this.vehicleSpecific ? " (" + load.vehicleRegisterNumber + ")" : "");
    }
}

@Component({
    components: {
        PlanTaskDistanceDialog,
        VehicleCalendar,
        VehicleSelectDialog
    }
})
export default class PlanTaskLoadTransportPartsDialog extends Vue {
    @Prop() load!: TransportLoad;

    saving = false;
    transportParts: TransportPartModel[] | null = null;
    distanceDialogPart: TransportPartModel | null = null;
    selectedListItems: number[][] = [];

    get groupedTransportParts(): any[] {
        if (!this.transportParts) {
            return [];
        }

        const grouped = this.transportParts.reduce((prev: any, cur) => {
            if (cur.type === "TRANSITION") { // Do not include transitions to mobile transport planning
                return prev;
            }
            if (!prev[cur.type]) {
                prev[cur.type] = [cur];
            } else {
                prev[cur.type].push(cur);
            }
            return prev;
        }, {});

        return Object.keys(grouped).map(key => ({ key, transportParts: grouped[key] }));
    }

    async mounted(): Promise<void> {
        const data = await transportLoadActionService.getLoadTransportParts(this.load.loadId);
        this.transportParts = data.filter(p => p.available).map(p => new TransportPartModel(p, this.load));
        this.selectedListItems = [];
        for (const tp of this.transportParts) {
            this.selectedListItems.push([]);
        }
    }

     get distanceDefaults(): { start: string; end: string } {
        const firstTask = this.load.loadTasks.map(lt => lt.task).filter(t => t != null)[0];
        if (!firstTask) {
            return { start: "", end: "" };
        }
        return { start: firstTask.senderParty.zipCode, end: firstTask.receiverParty.zipCode };
    }

    setDistance(distance: Distance): void {
        if (!this.distanceDialogPart) {
            return;
        }
        this.distanceDialogPart.amount = distance.kilometers;
        this.distanceDialogPart.cityFrom = distance.startPlace;
        this.distanceDialogPart.cityTo = distance.endPlace;
    }

    get canSubmit(): boolean {
        if (!this.transportParts) {
            return false;
        }
        return this.transportParts.filter(p => p.selected).length > 0;
    }

    async submit(): Promise<void> {
        if (!this.transportParts) {
            return;
        }
        const parts = this.transportParts
            .filter(p => p.selected)
            .map(p => {
                let amount: number | null = p.amount;
                if (isNaN(amount) || amount < 0) {
                    amount = null;
                }
                return {
                    partyTransportPartId: p.transportPart.part.partyTransportPartId,
                    plannedValue: amount,
                    cityFrom: p.cityFrom,
                    cityTo: p.cityTo,
                } as TransportLoadTransportPartSaveRequest;
            });

        this.saving = true;

        await transportLoadActionService.saveLoadTransportParts(this.load.loadId, parts);

        // this.load.transportParts = (await loadService.getLoad(this.load.loadId)).transportParts;

        this.saving = false;

        this.$emit("close");
    }
}
